import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { push } from "react-router-redux";
import classNames from "classnames";
import isEmpty from "is-empty";
import qs from 'querystring';

import { userForgotPassword } from "../actions";
import { segmentEventTracker } from '../../../utils/SegmentEventTracker'
import { TrackEventName, PageViewName } from '../../shared/constants/SegmentEvents';

import logo from "../../../assets/images/branding/logo-blue.svg";

import Layout from "../../shared/components/layouts/FullPageLayout";
import ZendeskComponent from "../../shared/components/misc/ZendeskComponent";
import TextInput from "../../shared/components/forms/TextInput";
import StringValidations from "../../../utils/StringValidations";

const isZendeskEnabled = process.env.REACT_APP_ZENDESK_ENABLED === 'true';

export class ForgotPasswordContainer extends Component {
  state = {
    email: this.emailFromLoginPage,
    loading: false,
    error: {},
    disabled: this.checkEmailValue,
  };

  componentDidMount(){
    segmentEventTracker.trackPageView(PageViewName.FORGOT_PASSWORD_VIEWED);
  }

  onSubmit = () => {
    segmentEventTracker.trackEvent(TrackEventName.SUBMIT_FORM_CLICKED);
    this.props.userForgotPassword( {email: this.state.email} );
  }

  goBackToLogin = () => {
    segmentEventTracker.trackEvent(TrackEventName.GO_BACK_TO_LOGIN_PAGE_CLICKED);
    this.props.push("/login")
  }

  onChangeEmail = (e) => {
    const email = e.target.value;
    const isValidEmail = !this.emailRegex.test(email)
    this.setState({  email: email, disabled: isValidEmail })
  }

  get emailFromLoginPage() {
    return (qs.parse(window.location.search).email || "").replace(/ /g,"+")
  }

  get emailRegex() {
    return StringValidations.emailValidationRegex();
  }

  get checkEmailValue() {
    const email = this.emailFromLoginPage
    return email.length === 0 || !this.emailRegex.test(email) ? true : false
  }

  submitButtonClassnames() {
    return classNames(
      "ds-btn",
      "--medium",
      "--full",
      "--btn-center",
      {"_loading": this.state.loading},
    );
  }

  renderError() {
    return (
      <section className="cardSection ds-notice -danger">
        <p className="copy">{this.state.error.email}</p>
      </section>
    );
  }

  render() {
    if (!!this.props.auth_token) return <Redirect to={{pathname: "/"}} />

    return (
      <Layout gridClassName="--narrow _marginTop--epic">
        <div className="logo _atLogin">
          <img
            src={logo}
            alt="Logo"
          />
        </div>

        <div className="ds-card _solo">
          {!isEmpty(this.state.error) && this.renderError()}
          <section className="cardSection">
            <h1 className="subhead" id="subhead-content">Forgot your password?</h1>
            <p className="copy" id="copy-content">We will email you the password reset link</p>
          </section>
          <section className="cardSection">
            <label className="ds-input" htmlFor="email">
              <span>Email</span>
              <TextInput
                name="email"
                placeholder="Enter Email Address"
                value={this.state.email}
                onChange={this.onChangeEmail}
                id="email-input-field"
              />
            </label>
          </section>
          <div className="center-alignment-wrapper">
            <button
              className={this.submitButtonClassnames()}
              onClick={this.onSubmit}
              disabled={this.state.disabled || this.state.loading}
              id="reset-pw-send-btn"
              data-test="submit-form-button"
            >
              Send Password Reset Link
            </button>
          </div>
        </div>

        <a
          className="ds-btn _link"
          onClick={this.goBackToLogin}
          data-test="go-back-to-login-button"
        >
          Go back to Login Page
        </a>
        { isZendeskEnabled && <ZendeskComponent /> }
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth_token: state.user.auth_token,
  };
};

const matchDispatchToProps = (dispatch, props) => {
  return {
    userForgotPassword: (payload)                       => dispatch( userForgotPassword( payload )),
    push:               (path, payload)                 => dispatch( push({ pathname: path, state: payload}) ),
  };
};

export default connect(mapStateToProps, matchDispatchToProps)(ForgotPasswordContainer);



// WEBPACK FOOTER //
// ./src/features/user/containers/ForgotPassword.js